import React from "react"
import axios from "axios";
import { setup as URI_SETUP } from "../../../../config/api";
import { Switch, Icon, notification, Checkbox } from 'antd';

const uri_catalogs = URI_SETUP+"catalog";
const uri_upload_csv = URI_SETUP+"data_source/csv/upload";


class CorporativeParsing extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            catalog_list                    : [],
            imported_list                   : [],
            catalog_alias_list              : [],
            status_importation_modal        : "hide",
            selected_catalog                : {
                                                    _id         : "",
                                                    name        : {
                                                        en : "",
                                                        es : "",
                                                    }   
                                                },
            catalog_item                    : {
                                                _id         : "",
                                                name        : ""
                                            },
            status_catalog_selected         : "hide",
            status_catalog_item_modal       : "hide",
            catalog_item_action             : "new",
            catalog_item_open               : "",
            background_filter               : "",
            status_magnum_leap_hotel        : "hide",
            status_sub_category             : "hide",
            background_filter               : "",
            dbfile                          : "",
            file_name                       : "CHOOSE FILE",
            dbschema                        : "",
            dragged_over                    : "",
            progress_bar                    : 0,
            actual_notice                   : 0,
            actual_msg                      : [],
            status_manual_importation       : "disabled",
            header_included                 : true,
            loading_imported_values         : false,
            loading_catalog_list            : false,
            loading_catalog_values          : false,
            loading_catalog_alias           : false,
            multiselect                     : [],
            multiselect_key                 : [],
            level                           : 0
            }
    }

    componentWillMount(){
        if(this.props.app.state.parsing_schema_list[0]!=undefined){
            this.setState({ 
                dbschema      : this.props.app.state.parsing_schema_list[0],
                status_manual_importation       : ""
                })
        }else{
            this.setState({ 
                status_manual_importation       : "disabled"
                })
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.hotel_selected != this.props.hotel_selected) {
            
            this.props.refreshCatalogSys(this.props.hotel_selected);
            if(this.state.selected_catalog.id!=undefined){
                this.handleCatalogSelector(this.state.selected_catalog,this.state.level);
            }

            if(this.props.app.state.parsing_schema_list[0]!=undefined){
                this.setState({ 
                    dbschema      : this.props.app.state.parsing_schema_list[0],
                    status_manual_importation       : ""
                    })
            }else{
                this.setState({ 
                    status_manual_importation       : "disabled"
                    })
            }
        }

        if (prevState.progress_bar != this.state.progress_bar) {

            const actual_msg = this.state.actual_msg;
            actual_msg['progress'] = this.state.progress_bar;
            this.setState({ actual_msg });

            this.props.handleNotification("tmp","update",actual_msg,this.state.actual_notice);
            
        }

        if (prevState.catalog_list != this.state.catalog_list && this.state.selected_catalog.id!=undefined) {

            axios.get(uri_catalogs+"/"+this.state.selected_catalog.id, { 
                params: {
                    api_token   : localStorage.getItem("api_token"),
                    mode        : 'refresh_imported',
                    property_id : this.props.app.state.hotel_selected,
                    level       : this.state.level
                }
            }).then(request => { 
                this.setState({ 
                imported_list                   : request.data.imported_catalogs,
                loading_imported_values         : false,
                }) 
            })
            
        }


    }

    // ----------------------- Handlers -----------------------

    handleMultipleSelector(id,key){
        let multiselect = this.state.multiselect;
        let multiselect_key = this.state.multiselect_key;
        if(multiselect.includes(id)){
            let index_selected = multiselect.indexOf(id);
            multiselect.splice(index_selected , 1 );
            multiselect_key.splice( index_selected, 1 );
        }else{
            multiselect.push(id);
            multiselect_key.push(key);
        }
        this.setState({ multiselect, multiselect_key });
    }

    handleFileHeader(checked) {this.setState({header_included  : checked });}
    
    handleCatalogItemOpen(id,key){
        let item_opened = "";
        if(this.state.catalog_item_open!=id){
            item_opened = id;
        }
        if(item_opened!=''){
            let catalog_list  = this.state.catalog_list;
            this.getAliasDetails(id,key);
        }
        this.setState({ 
            catalog_item_open             : item_opened
            }) 
    }

    handleCatalogSelector(catalog, level=0) {
        let self = this;
        self.setState({ 
            selected_catalog            : catalog,
            status_catalog_selected     : "",
            loading_imported_values     : true,
            loading_catalog_list        : true
            }) 

        axios.get(uri_catalogs+"/"+catalog.id, { 
            params: {
                api_token   : localStorage.getItem("api_token"),
                mode        : 'parsing',
                property_id : self.props.app.state.hotel_selected,
                level       : level
            }
        }).then(request => { 
            self.setState({ 
            catalog_list                : request.data.available_catalogs,
            loading_catalog_list        : false,
            }) 
        })
    }

    handleImportingManual(e) {
        e.preventDefault();
        this.setState({ 
            status_importation_modal      : "",
            background_filter             : "blur"
            })
    }

    handleFileSelector(e) {
        if(e[0] != undefined){
            this.setState({ 
                dbfile      : e[0],
                file_name   : e[0].name
                })
        }
    }

    handleImportationSchema(e){ 
        this.setState({ 
            dbschema      : this.props.app.state.parsing_schema_list[e.target.value]
            })
        
    }

    handleCatalogLevel = (e) => {
        this.setState({
            level : e.target.value
        });
        this.handleCatalogSelector(this.state.selected_catalog,e.target.value);
    }


    // ----------------------- Functions -----------------------
    getAliasDetails(id,key){
        var qs = require("qs");
        this.setState({ 
            loading_catalog_alias : true
         }) 
        let catalog_list  = this.state.catalog_list;
        const valuesToSent = qs.stringify({
            api_token   : localStorage.getItem("api_token"),
            action      : 'get-alias',
            property_id : this.props.app.state.hotel_selected
        });
        axios.post(uri_catalogs+"/"+this.state.selected_catalog.id+"/"+id, valuesToSent).then(request => { 

            if(request.data!=undefined){
                catalog_list[key].alias_list = request.data;
                catalog_list[key].alias_total = catalog_list[key].alias_list.length;
                this.setState({ 
                    catalog_list,
                    loading_catalog_alias : false }) 
                
            }

        })  
    }

    onDragStart = (ev, id ,key) => {
        ev.dataTransfer.setData("id", id);
        ev.dataTransfer.setData("key", key);
    }

    onDragOver = (ev,id) => {
        ev.preventDefault();
        let dragged_over= this.state.dragged_over;
        if(dragged_over!=id){
            this.setState({ 
                dragged_over            : id
                })
        }
        

    }

    onDragLeave = (ev) => {
        ev.preventDefault();
        this.setState({ 
            dragged_over            : ""
            })

    }

    onDrop = (ev, alias_id, alias_key) => {
        let id = ev.dataTransfer.getData("id");
        let key = ev.dataTransfer.getData("key");

        var qs = require("qs");
        let catalog_list = this.state.catalog_list;
        let imported_list = this.state.imported_list;
        let multiselect = this.state.multiselect;
        let amount = 0
        if(multiselect.indexOf(id)>=0 ){
            let multiselect_key = this.state.multiselect_key;
            multiselect_key.map((imported_key) => {
                catalog_list[alias_key].alias_list.push(imported_list[imported_key]);
                catalog_list[alias_key].alias_total+=1;
                //imported_list.splice( (imported_key-amount), 1 );
                amount++;
                });
            this.setState({ 
                catalog_list,
                imported_list,
                dragged_over            : "",
                loading_imported_values : true
                }) 
            
            const valuesToSent = qs.stringify({
                items_to_assign     : multiselect,
                action              : 'assign_multiple_alias',
                api_token           : localStorage.getItem("api_token"),
                property_id         : this.props.app.state.hotel_selected,
                level               : this.state.level
            });

            axios.post(uri_catalogs+"/"+this.state.selected_catalog.id+"/"+alias_id, valuesToSent)
                .then(request => {  
                    notification.open({
                        message: request.data.result.type,
                        description: request.data.result.message,
                    });
                    if(request.data.result.values != undefined){
                        this.setState({ 
                            imported_list            : request.data.result.values.imported_catalogs,
                            multiselect              : [],
                            multiselect_key          : [],
                            loading_imported_values  : false
                        })
                    }
                });
    

        }else{
            amount = 1;
            catalog_list[alias_key].alias_list.push(imported_list[key]);
            catalog_list[alias_key].alias_total+=1;
            imported_list.splice( key, 1 );

            this.setState({ 
                catalog_list,
                imported_list,
                dragged_over            : "",
                loading_imported_values : true
                })
            
            const valuesToSent = qs.stringify({
                alias_id    : alias_id,
                action      : 'assign_alias',
                api_token   : localStorage.getItem("api_token"),
                property_id : this.props.app.state.hotel_selected,
                level       : this.state.level
            });
            
            axios.post(uri_catalogs+"/"+this.state.selected_catalog.id+"/"+id, valuesToSent)
                .then(request => {  
                    notification.open({
                        message: request.data.result.type,
                        description: request.data.result.message,
                    });
                    if(request.data.result.values != undefined){
                        this.setState({ 
                            imported_list            : request.data.result.values.imported_catalogs,
                            multiselect              : [],
                            multiselect_key          : [],
                            loading_imported_values  : false
                        }) 
                    }
                    //this.handleCatalogSelector(this.state.selected_catalog,this.state.level);
                    //this.props.refreshCatalogSys(this.props.hotel_selected);
                })  
        }
        this.getAliasDetails(alias_id,alias_key);
        this.props.updateCatalogCounter(this.state.selected_catalog,this.props.app.state.hotel_selected,(-1)*amount);
    }

    unassignAlias (id, key, key_alias) {
        var qs = require("qs");
        var catalog_list = this.state.catalog_list;
        let imported_list = this.state.imported_list;

        imported_list.unshift(catalog_list[key].alias_list[key_alias]);
        catalog_list[key].alias_total-=1;
        catalog_list[key].alias_list.splice( key_alias, 1 );

        this.setState({ 
            catalog_list,
            imported_list,
            multiselect              : [],
            multiselect_key          : []
            })

        const valuesToSent = qs.stringify({
             action      : 'unassign_alias',
             api_token   : localStorage.getItem("api_token"),
             property_id : this.props.app.state.hotel_selected,
             level       : this.state.level
         });
         
        axios.post(uri_catalogs+"/"+this.state.selected_catalog.id+"/"+id, valuesToSent)
            .then(request => {  
            notification.open({
                message: request.data.result.type,
                description: request.data.result.message,
            });
            if(request.data.result.values != undefined){
                this.setState({ 
                    imported_list            : request.data.result.values.imported_catalogs,
                    multiselect              : [],
                    multiselect_key          : []
                }) 
            }
            //this.handleCatalogSelector(this.state.selected_catalog,this.state.level);
            //this.props.refreshCatalogSys(this.props.hotel_selected);
            }) 
            this.props.updateCatalogCounter(this.state.selected_catalog,this.props.app.state.hotel_selected,1);    
        }

    cancelManualImportation(){
        let self = this;
        self.setState({ 
            status_importation_modal            : "hide",
            background_filter                   : "",
            dbfile                              : "",
            file_name                           : "CHOOSE FILE"
            })
    }

    ignoreImportatedValue (id) {
        var qs = require("qs");
        const valuesToSent = qs.stringify({
             api_token   : localStorage.getItem("api_token")
         });
        axios.post(uri_catalogs+"/"+this.state.selected_catalog.id+"/"+id+"/destroy", valuesToSent)
                .then(request => { 
                    notification.open({
                        message: request.data.result.type,
                        description: request.data.result.message,
                    });
                    this.props.refreshCatalogSys(this.props.hotel_selected); 
                    this.handleCatalogSelector(this.state.selected_catalog,this.state.level);
                })  
    }

    onSubmitImportation(e){
        let self = this;   

        e.preventDefault();
        if(this.state.dbfile!='' && self.state.dbschema!=''){

            let formData = new FormData();
            formData.append('dbfile', self.state.dbfile);
            formData.append('dbschema', self.state.dbschema._id);
            formData.append('header_included', self.state.header_included);
            formData.append('api_token', localStorage.getItem("api_token"));

            self.setState({ 
                status_importation_modal            : "hide",
                background_filter                   : ""
                });

            let notification_key;
            let msg = { 
                title               : "IMPORTATION",
                msg                 : "Uploading file to Magnum leap",
                day                 : "Now",
                progress            : 0,
                datetime            : Date.now()
                }

                notification_key = self.props.handleNotification("tmp","new",msg);
                self.setState({
                    actual_notice: notification_key,
                    actual_msg: msg
                }); 
                /*
                const config = { onUploadProgress:function (progressEvent) {
                    const totalLength = progressEvent.lengthComputable ? progressEvent.total : progressEvent.target.getResponseHeader('content-length') || progressEvent.target.getResponseHeader('x-decompressed-content-length');

                    if (totalLength !== null) {
                        let percentCompleted=(Math.round( (progressEvent.loaded * 100) / totalLength ));
                        self.setState({progress_bar: percentCompleted}); 
                        //self.props.handleNotification("update",msg,notification_key);
                    }
                }
                }; */
            
            axios.post(uri_upload_csv, formData, /*config */)
                    .then(request => { 
                        
                        notification.open({
                            message: request.data.result.type,
                            description: request.data.result.message,
                        });
                        
                        this.props.refreshCatalogSys(this.props.hotel_selected);
                        
                    })
            
        }
        
    }

    // ----------------------- Renders -----------------------

    renderSelectParsingSchemas() {
          if(this.state.status_manual_importation==""){
            return  <select className="form-control top-form-select " name="parsing_schema" value={this.state.hotel_id} onChange={e => this.handleImportationSchema(e)}  >
                        <option disabled>Importation Schema</option>
                        {Object.keys(this.props.app.state.parsing_schema_list).map((key, index) => {
                            return ( <option value={key} key={index}> {this.props.app.state.parsing_schema_list[key].name}</option>);
                            })
                        }
                    </select>
        }else{
            return <a className={"button blue"} onClick={this.props.activeSection.bind(this,"setup","import-data",this.props.app.state.hotel_selected,"")} >SETUP IMPORTATION</a>
        }
    }

    renderCatalogs() {
        let self = this;
        return <ul>
                    {   
                        this.props.catalogs.map(function(catalog, i) {
                            if(catalog.type.indexOf("hotels")>=0 && catalog[self.props.app.state.hotel_selected]!= undefined ){
                                return (<li className="clickable" key={catalog.id} onClick={self.handleCatalogSelector.bind(self, catalog, self.state.level)} >
                                    <div>{catalog.name.en}  
                                        <i className="fa fa-angle-down"></i>
                                        { (catalog[self.props.app.state.hotel_selected].pendings>0) &&
                                            <span className= "float-right circle-note red" > { catalog[self.props.app.state.hotel_selected].pendings  } </span>
                                        }
                                    </div>
                                </li>);
                                }
                            })
                    }
                </ul>   
    }

    renderCatalogItems() {
        return  <ul>
                    <li className="list-header">
                        <div className="label">
                            {this.state.selected_catalog.name.en} 
                            <i className="fa edit fa-plus-circle clickable" onClick={this.props.activeSection.bind(this,"setup","catalogs",this.props.app.state.hotel_selected,this.state.selected_catalog)}></i>
                        </div>
                    </li>
                    <li className="radio-inlist">
                        <div className="form-row">
                            <div className="col-md-2 col-md-offset-2"> Display </div>
                            <div className="col-md-6 col-md-offset-1">  
                                <select className="form-control" name="llver" value={this.state.level} onChange={e => this.handleCatalogLevel(e)}  >
                                    <option value="0">Values</option>
                                    <option value="1">Groups</option>
                                </select>  
                            </div>
                        </div>
                    </li>
                    { (this.state.loading_catalog_list) &&
                        <li className="radio-inlist loading"> 
                            <Icon type="loading" />
                        </li>
                    }
                    { (!this.state.loading_catalog_list) && 
                        Object.keys(this.state.catalog_list).map((key, index) => {
                            return (<li key={this.state.catalog_list[key]._id.$oid} 
                                        className={"sub-list " + (this.state.catalog_item_open==this.state.catalog_list[key]._id.$oid? "" : "collapsed" )}
                                    >
                                        <div 
                                        className={(this.state.dragged_over==this.state.catalog_list[key]._id.$oid)?"dragged-over":""}
                                        onDragOver={(e)=>this.onDragOver(e, this.state.catalog_list[key]._id.$oid)}
                                        onDragLeave={(e)=>this.onDragLeave(e)}
                                        onDrop={(e)=>{this.onDrop(e, this.state.catalog_list[key]._id.$oid, key)}}>
                                            {this.state.catalog_list[key].name}
                                            <i  className={"clickable fa " + (this.state.catalog_item_open==this.state.catalog_list[key]._id.$oid? "fa-angle-up" : "fa-angle-down" )} 
                                                onClick={this.handleCatalogItemOpen.bind(this,this.state.catalog_list[key]._id.$oid,key)} >
                                            </i>

                                            <span className= {(this.state.catalog_list[key].alias_total==0)? "hidden" : "float-right circle-note gray"  } > {this.state.catalog_list[key].alias_total} </span>
                                        </div>
                                        {  (this.state.loading_catalog_values) &&
                                            <div className="loading"> 
                                                <Icon type="loading" />
                                            </div>
                                        }
                                        { (!this.state.loading_catalog_values) &&
                                            this.renderCatalogAliasItems(this.state.catalog_list[key]._id.$oid, this.state.catalog_list[key].alias_list, key) 
                                        }
                                    </li>);
                            }
                    )
                        
                    }
                </ul>   
    }

    renderCatalogAliasItems(id,alias_list,key) {
        return  <ul className="alias-listing" 
                    onDragOver={(e)=>this.onDragOver(e, id)}
                    onDragLeave={(e)=>this.onDragLeave(e)}
                    onDrop={(e)=>{this.onDrop(e, id, key)}}>
                    { (this.state.loading_catalog_alias) &&
                        <li className="radio-inlist loading-small"> 
                            <Icon type="loading" />
                        </li>
                    }
                    { (!this.state.loading_catalog_alias) && 
                        Object.keys(alias_list).map((key_alias, index) => {
                            return (<li key={alias_list[key_alias]._id.$oid} >
                                        <div>
                                            {alias_list[key_alias].name}
                                            <i className="fa fa-times-circle remove clickable" onClick={this.unassignAlias.bind(this,alias_list[key_alias]._id.$oid, key, key_alias)} ></i><br />
                                            { (alias_list[key_alias].parsing_queue!=undefined) &&
                                                <span className="item-details"> {alias_list[key_alias].parsing_queue.parsing_schema.name}</span>
                                            }
                                        </div>
                                    </li>);
                            }
                        )   
                    }   
                </ul>   
    }

    renderImportedItems() {
        return  <ul>
                    <li className="sub-list" ><div>{this.state.selected_catalog.name.en} <i className="fa fa-angle-down"></i>  </div>
                        <ul>    
                            { (this.state.loading_imported_values) &&
                                <li className="radio-inlist loading"> 
                                    <Icon type="loading" />
                                </li>
                            }
                            { (!this.state.loading_imported_values) && 
                                Object.keys(this.state.imported_list).map((key, index) => {

                                    return (<li key={this.state.imported_list[key]._id.$oid} className="clickable" draggable="true" onDragStart = {(e) => this.onDragStart(e, this.state.imported_list[key]._id.$oid, key)} >
                                                <div className="item-with-details">
                                                    {this.state.imported_list[key].name}    
                                                    
                                                    <i className="fa fa-times-circle remove clickable" onClick={this.ignoreImportatedValue.bind(this,this.state.imported_list[key]._id.$oid)} ></i>
                                                    <Checkbox name={key} value={this.state.imported_list[key]._id.$oid} onChange={this.handleMultipleSelector.bind(this,this.state.imported_list[key]._id.$oid,key)}> </Checkbox>
                                                    <br />
                                                    { (this.state.imported_list[key].parsing_queue!=undefined) &&
                                                        <span className="item-details"> {this.state.imported_list[key].parsing_queue.parsing_schema.name}</span>
                                                    }
                                                    
                                                </div>
                                                
                                            </li>);
                                    
                                })
                            
                            }
                        </ul>
                    </li>
                        
                </ul>   
    }

    renderManualImportationModal() {
        return <div className="box regular col-md-4 ">
                    <h3>MANUAL IMPORTATION  <i className="fa fa-times-circle" onClick={this.cancelManualImportation.bind(this)} ></i> </h3>
                    <div className="form-in-box">
                        <form onSubmit={this.onSubmitImportation.bind(this)}>
                            <div className="form-row importing-csv">
                                <div className="col col-md-9">
                                    <button>{this.state.file_name} </button>
                                    <input type="file" name="dbfile" onChange={ (e) => this.handleFileSelector(e.target.files) } key={this.state.dbfile || '' } /> 
                                </div>
                            
                                <div className="col col-md-3">
                                    <select className="form-control " name="hotel_id" >
                                        <option disabled>FILE TYPE</option>
                                        <option value="csv">.csv</option>
                                    </select> 
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="col col-md-9">
                                    <label>This file has header:</label>      
                                </div>
                                <div className="col col-md-2">
                                    <Switch onChange={this.handleFileHeader.bind(this)} checked={this.state.header_included}  />   
                                </div> 
                            </div>
                            <div className="form-row modal-buttons">
                                <div className="col col-md-6">
                                    <button onClick={this.cancelManualImportation.bind(this)}>CANCEL</button>   
                                </div>
                                <div className="col col-md-6">
                                    <button type="submit" className="blue">IMPORT</button> 
                                </div>
                            </div>
                            
                        </form>
                    </div>
                </div>

    }

    render() {
        return (
            <section>
                <div className={this.state.background_filter}>
                    <div className="top-form ">
                        <form id="catalog_item_form"  >
                            <div className="form-row">
                                <div className="col col-md-3">
                                    {this.props.renderSelectHotels()}
                                </div>
                                <div className="col col-md-3">
                                    {this.renderSelectParsingSchemas()}
                                </div>
                                <div className="col col-md-3">
                                    <button className={"blue " + this.state.status_manual_importation} onClick={this.handleImportingManual.bind(this)} >MANUAL IMPORTATION</button>
                                </div>
                            </div>
                        </form>
                    </div>

                    <div className="head-content "> 
                    <div className="icon col-md-2 px-2">
                            <h1>Setup</h1>
                            <h2>Import Your Data</h2>
                        </div>
                        <div className="col-md-8 px-2">    
                            
                            <div className="description">
                                <p className="desc-no-icon"><strong>After you’ve imported your data manually, now it’s time to assign, or associate, </strong> <br/> your imported database data with the segments, plans and other KPIs you set up in Magnum Leap in Step 2. Drag &amp; drop the fields to arrange the data that you imported. </p>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-12 no-padding"> 
                        <div className="box regular col-md-4">
                            <h3>MAGNUM LEAP CORP</h3>
                            <div className="list-in-box">
                                {this.renderCatalogs()}
                            </div>
                        </div>
                        <div className={"box regular col-md-4 " + this.state.status_catalog_selected}>
                            <h3>SUB CATEGORY</h3>
                            <div className="list-in-box">
                                {this.renderCatalogItems()}
                            </div>
                        </div>
                        <div className={"box regular col-md-4 " + this.state.status_catalog_selected}>
                            <h3>PMS HOTEL</h3>
                            <div className="list-in-box">
                            {this.renderImportedItems()}
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"modal " + this.state.status_importation_modal}> 
                    {this.renderManualImportationModal()}
                </div>

            </section>
        )
    }

}

export default CorporativeParsing


// WEBPACK FOOTER //
// ./src/Setup/modules/setup/views/property/ParsingDB.js